import smoothscroll from 'smoothscroll-polyfill'
import 'intersection-observer'

smoothscroll.polyfill()
